export function playerFactory() {
  return import('lottie-web');
}
